import { render, staticRenderFns } from "./AdminFormula.vue?vue&type=template&id=551596d4&scoped=true&"
import script from "./AdminFormula.vue?vue&type=script&lang=js&"
export * from "./AdminFormula.vue?vue&type=script&lang=js&"
import style0 from "./AdminFormula.vue?vue&type=style&index=0&id=551596d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551596d4",
  null
  
)

export default component.exports